import moment from 'moment';
import {USEROLES} from 'common/domain/constants';
import Swipe from 'common/utils/swipe';

const MANAGER_PERMISSION = 'A';

class DelegationCardController {
  constructor($timeout) {
    'ngInject';
    this.timeout = $timeout;
  }

  $onInit() {
    this.startDate = this.formatDate(this.delegationInfo.startDate);
    this.endDate = this.formatDate(this.delegationInfo.endDate);
    this._initType();
  }

  $postLink() {
    if (this.isMobileApp) {
      this.timeout(() => {
        this.initSwipe();
      });
    }
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
      swiped: this.swiped
    };
  }

  initSwipe() {
    const swiper = new Swipe(this.getDelegationCardSelector());
    swiper.onLeft(() => this.onSwipeLeft());
    swiper.onRight(() => this.onSwipeRight());
    swiper.run();
  }

  getDelegationCardSelector() {
    return `delegation-card .${this.cardId}`;
  }

  onSwipeRight() {
    this.timeout(() => {
      this.swiped = false;
    });
  }

  onSwipeLeft() {
    this.timeout(() => {
      this.swiped = true;
    });
  }

  formatDate(date, lang = 'es') {
    moment.locale(lang);
    let result = moment(date).format('dddd DD MMMM YYYY');
    return result;
  }

  _initType() {
    if (!this.delegationInfo.type) return;
    if (this.delegationInfo.type === MANAGER_PERMISSION) {
      this.permissionType = USEROLES.MANAGER;
    } else {
      this.permissionType = USEROLES.USER;
    }
  }
}

export default DelegationCardController;



// WEBPACK FOOTER //
// ./client/app/components/delegationsList/delegationCard/delegationCard.controller.js